import React, { Component } from "react";
import "./App.css";
import Routes from "./components/routes/Routes";
import NavigationBar from "./components/Navbar/NavigationBar";
import Sidebar from "./components/Navbar/Sidebar";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { mqttConnectionInit } from "./actions/mqttAction";
import ReactNotifications from "react-notifications-component";

class App extends Component {

  componentDidMount() {
    console.log("checking notification permissions ...")
    if (!("Notification" in window)) {
      console.log("Browser does not support desktop notification");
    } else {
      Notification.requestPermission();
    }
  }

  connectToMqtt() {
    this.props.mqttConnectionInit();
  }
  render() {
    const isAuthenticated = this.props.isAuthenticated;
    return (
      <div className="App  main-container ">
        {!isAuthenticated ? (
          <Routes />
        ) : (
          <div>
            <NavigationBar />
            {/* <Sidebar /> */}
            <div className="main-panel">
              <div className="main-content">
                <div className="content-wrapper">
                  <ReactNotifications />

                  <Routes />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

App.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  mqttConnectionInit: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  isAuthenticated: !!state.auth.isAuthenticated
});

export default withRouter(
  connect(mapStateToProps, { mqttConnectionInit })(App)
);
